import { render, staticRenderFns } from "./TransactionsTableV2.vue?vue&type=template&id=bb446576&"
import script from "./TransactionsTableV2.vue?vue&type=script&lang=js&"
export * from "./TransactionsTableV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb446576')) {
      api.createRecord('bb446576', component.options)
    } else {
      api.reload('bb446576', component.options)
    }
    module.hot.accept("./TransactionsTableV2.vue?vue&type=template&id=bb446576&", function () {
      api.rerender('bb446576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Tables/TransactionsTableV2.vue"
export default component.exports